// extracted by mini-css-extract-plugin
module.exports = {"curtain":"Modal_curtain__3jazO","content":"Modal_content__2j-or","active":"Modal_active__2zgwL"};